import { render, staticRenderFns } from "./NsbDetail.vue?vue&type=template&id=fc041e40&scoped=true&"
import script from "./NsbDetail.vue?vue&type=script&lang=js&"
export * from "./NsbDetail.vue?vue&type=script&lang=js&"
import style0 from "./NsbDetail.vue?vue&type=style&index=0&id=fc041e40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc041e40",
  null
  
)

export default component.exports